module.exports = __webpack_public_path__ + "img/P42.4e4a3e55.png";